import { IconButton, Tooltip } from '@salecycle/ui-component-library';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { TooltipHtml } from './TooltipHtml';
export declare type Position = 'left' | 'right' | 'top' | 'bottom';
interface IProps {
  icon: string;
  onClick?: (e?: React.MouseEvent) => void;
  tooltipHeading?: string;
  tooltipDescription?: string;
  tooltipPosition?: Position;
  openBlankTab?: boolean;
}

export const TooltipButton = (props: IProps) => {
  const { siteId, id, language } = useParams<{ siteId: string; id: string; language: string }>();
  return (
    <Tooltip
      title={props.tooltipHeading}
      html={<TooltipHtml heading={props.tooltipHeading} description={props.tooltipDescription} />}
      position={props.tooltipPosition}
    >
      {props.openBlankTab ? (
        <Link to={`/sites/${siteId}/designs/templates/${id}/${language}/preview`} target="_blank">
          <IconButton icon={props.icon} ariaLabel={props.tooltipHeading} onClick={props.onClick} />
        </Link>
      ) : (
        <IconButton icon={props.icon} ariaLabel={props.tooltipHeading} onClick={props.onClick} />
      )}
    </Tooltip>
  );
};
